/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTabsProps, TdTabPanelProps } from './type';

export const tabsDefaultProps: TdTabsProps = {
  addable: false,
  disabled: false,
  dragSort: false,
  placement: 'top',
  scrollPosition: 'auto',
  size: 'medium',
  theme: 'normal',
};

export const tabPanelDefaultProps: TdTabPanelProps = {
  destroyOnHide: true,
  disabled: false,
  draggable: true,
  lazy: false,
  removable: false,
};
